import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ReferredJobDetailTabState } from '@doda/common/src/constants/referredJobDetail/tabState';
import { RootState } from '@doda/pc/src/redux/store';

/**
 * Ui State
 */
export interface UiState {
  isLanguageVisible: boolean;
  isSalaryVisible: boolean;
  isRequiredApplicationVisible: boolean;
  tabState: ReferredJobDetailTabState;
}

export const uiInitialState: UiState = {
  isLanguageVisible: false,
  isSalaryVisible: false,
  isRequiredApplicationVisible: false,
  tabState: 'jobSummary',
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState: uiInitialState,
  reducers: {
    setIsLanguageVisible: (state, action: PayloadAction<boolean>) => {
      state.isLanguageVisible = action.payload;
    },
    setIsSalaryVisible: (state, action: PayloadAction<boolean>) => {
      state.isSalaryVisible = action.payload;
    },
    setIsRequiredApplicationVisible: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isRequiredApplicationVisible = action.payload;
    },
    setTabState: (state, action: PayloadAction<ReferredJobDetailTabState>) => {
      state.tabState = action.payload;
    },
  },
});

// Create Action
export const {
  setIsLanguageVisible,
  setIsSalaryVisible,
  setIsRequiredApplicationVisible,
  setTabState,
} = uiSlice.actions;

// reducer
export const uiReducer = uiSlice.reducer;

// Selector
/**
 * isLanguageVisibleSelector
 * 『語学力』が画面内に入ったかどうか
 * @param state
 * @returns isLanguageVisible
 */
export const isLanguageVisibleSelector = (state: RootState) =>
  state.ui.isLanguageVisible;
/**
 * isSalaryVisibleSelector
 * 『賃金』が画面内に入ったかどうか
 * @param state
 * @returns isSalaryVisible
 */
export const isSalaryVisibleSelector = (state: RootState) =>
  state.ui.isSalaryVisible;
/**
 * 『応募時必要事項』が画面内に入ったかどうか
 * @param state
 * @returns isRequiredApplicationVisible
 */
export const isRequiredApplicationVisibleSelector = (state: RootState) =>
  state.ui.isRequiredApplicationVisible;
/**
 * タブstateのselector
 * @param state
 * @returns タブstate
 */
export const referredJobDetailTabStateSelector = (state: RootState) =>
  state.ui.tabState;
